import React from 'react';

import { PublicPage } from 'api/website';
import { getIsContentFullWidthLayout } from 'cms/helpers';
import { Box } from 'components/Box';
import Byline from 'components/Byline';
import { H1 } from 'components/Text';

import { ContentPageCategories } from './ContentPageCategories';

type Props = {
  content: PublicPage;
};

export function ContentPageBodyHeader({ content }: Props) {
  const fullWidthLayout = getIsContentFullWidthLayout({ content });

  return (
    <>
      {content.type === 'POST' &&
        content.categories &&
        content.categories.length > 0 && (
          <Box mb={24}>
            <ContentPageCategories
              categories={content.categories}
              homePageUrl={
                content.subsite.homePage && content.subsite.homePage.url
              }
            />
          </Box>
        )}

      <H1 m="0" textAlign={fullWidthLayout ? 'center' : 'left'}>
        {content.title}
      </H1>

      {(content.author || (content.postedDate && content.showDate)) && (
        <Box mt={4}>
          <Byline
            slug={content.author ? content.author.slug : undefined}
            name={content.author ? content.author.name : undefined}
            imageHandle={
              content.author && content.author.image
                ? content.author.image.handle
                : undefined
            }
            homePageUrl={
              content.subsite.homePage && content.subsite.homePage.url
            }
            postedDate={content.postedDate}
            showDate={content.showDate}
          />
        </Box>
      )}
    </>
  );
}
